/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const defaultOption = [
  {
    value: "title",
    label: "title",
    disabled: true,
  },
];

const billIDOption = [
  {
    value: "01BLP",
    label: "01BLP",
    disabled: false,
  },
  {
    value: "02BLP",
    label: "02BLP",
    disabled: false,
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    receiptId: {
      type: "select",
      value: null,
      bg: false,
      option: billIDOption,
    },
    receiptName: {
      type: "input",
      value: null,
      bg: false,
    },
    denominator: {
      type: "input",
      value: null,
      bg: false,
    },
    reiceiptSymbol: {
      type: "input",
      value: null,
      bg: false,
    },
    quantity: {
      type: "input",
      value: null,
      bg: false,
    },
    from: {
      type: "input",
      value: null,
      bg: false,
    },
    to: {
      type: "input",
      value: null,
      bg: false,
    },
    startDate: {
      type: "input",
      value: null,
      bg: false,
    },
    number: {
      type: "input",
      value: null,
      bg: false,
    },
    date: {
      type: "input",
      value: null,
      bg: false,
    },
    name: {
      type: "input",
      value: null,
      bg: false,
    },
    mst: {
      type: "input",
      value: null,
      bg: false,
    },
  },
];
export default function ReceiptTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const addNewRow = () => {
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      receiptId: {
        type: "select",
        value: null,
        bg: false,
        option: billIDOption,
      },
      receiptName: {
        type: "input",
        value: null,
        bg: false,
      },
      denominator: {
        type: "input",
        value: null,
        bg: false,
      },
      reiceiptSymbol: {
        type: "input",
        value: null,
        bg: false,
      },
      quantity: {
        type: "input",
        value: null,
        bg: false,
      },
      from: {
        type: "input",
        value: null,
        bg: false,
      },
      to: {
        type: "input",
        value: null,
        bg: false,
      },
      startDate: {
        type: "input",
        value: null,
        bg: false,
      },
      number: {
        type: "input",
        value: null,
        bg: false,
      },
      date: {
        type: "input",
        value: null,
        bg: false,
      },
      name: {
        type: "input",
        value: null,
        bg: false,
      },
      mst: {
        type: "input",
        value: null,
        bg: false,
      },
    };

    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <Typography component="label" variant="caption" fontWeight="bold" fontSize={14}>
          3 Các loại ấn chỉ được phát hành
        </Typography>
      </Grid>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Mã biên lai
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Tên loại biên lai
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Ký hiệu mẫu biên lai
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Ký hiệu biên lai
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Số lượng
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Từ số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Đến số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Ngày bắt đầu sử dụng
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Hợp đồng in/ Hợp đồng cung ứng phần mềm tự in biên lai
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Doanh nghiệp in hoặc cung ứng phần mềm in biên lai
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Số</Th>
              <Th style={{ textAlign: "center" }}>Ngày</Th>
              <Th style={{ textAlign: "center" }}>Tên</Th>
              <Th style={{ textAlign: "center" }}>MST</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(01)</Th>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center" }}>(02)</Th>
              <Th style={{ textAlign: "center" }}>(03)</Th>
              <Th style={{ textAlign: "center" }}>(04)</Th>
              <Th style={{ textAlign: "center" }}>(05)</Th>
              <Th style={{ textAlign: "center" }}>(06)</Th>
              <Th style={{ textAlign: "center" }}>(07)</Th>
              <Th style={{ textAlign: "center" }}>(08)</Th>
              <Th style={{ textAlign: "center" }}>(09)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
              <Th style={{ textAlign: "center" }}>(12)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {index + 1}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.receiptId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.receiptId.bg ? (
                      row.receiptId.value
                    ) : row.receiptId?.type === "select" ? (
                      <SelectTable
                        name="receiptId"
                        id={row.id.value}
                        option={row.receiptId.option ? row.receiptId.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="receiptId"
                        value={row.receiptId.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.receiptName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.receiptName?.type !== "input" ? (
                      row.receiptName.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="receiptName"
                        value={row.receiptName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.denominator.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.denominator?.type !== "input" ? (
                      row.denominator.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="denominator"
                        value={row.denominator.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.reiceiptSymbol.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.reiceiptSymbol?.type !== "input" ? (
                      row.reiceiptSymbol.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="reiceiptSymbol"
                        value={row.reiceiptSymbol.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="quantity"
                        min={0}
                        value={row.quantity.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.from.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.from?.type !== "input" ? (
                      row.from.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="from"
                        value={row.from.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.to.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.to?.type !== "input" ? (
                      row.to.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="to"
                        value={row.to.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.startDate.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.startDate?.type !== "input" ? (
                      row.startDate.value
                    ) : (
                      <InputTable
                        fields={"date"}
                        id={row.id.value}
                        name="startDate"
                        value={row.startDate.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.number.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.number?.type !== "input" ? (
                      row.number.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="number"
                        value={row.number.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.date.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.date?.type !== "input" ? (
                      row.date.value
                    ) : (
                      <InputTable
                        fields={"date"}
                        id={row.id.value}
                        name="date"
                        value={row.date.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.name.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.name?.type !== "input" ? (
                      row.name.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="name"
                        value={row.name.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.mst.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mst?.type !== "input" ? (
                      row.mst.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="mst"
                        value={row.mst.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
